{
	"invalidListItem": "O valor inserido não está na lista de opções válidas.",
	"invalidListTitle": "Valor inválido",
	"selectAValidOption": "Por favor, selecione um valor da lista.",
	"selectAValue": "Selecione um valor",
	"invalidValue": "O valor inserido não é válido.",
	"values": {
		"boolean": {
			"true": "Sim",
			"false": "Não"
		}
	}
}
